
<template>
  <vs-row vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <vs-card>
            <div class="p-4 flex flex-col w-full">
				<h3>
					Datos de Facturación
				</h3>
			</div>
            <div class="p-4 flex flex-col w-full">
			<div class="vx-col sm:w-3/4 w-full mb-2">
                <div class="search-results" style="width:100% !important;">
				    <v-select placeholder="Listado de clientes" v-model="selectCliente" label="nombres_completos" :options="listaClientes" :dir="$vs.rtl ? 'rtl' : 'ltr'" @click="computadaCliente"/>
                    <br>
                 </div>
			</div>
            </div>
            <div class="vx-row p-4 w-full">
				<div class="vx-col sm:w-1/4 w-full mb-2">
					<vs-input  :disabled="estado_numero_identificacion"
						type="number"
						label-placeholder="Name"
						name="numero_identificacion"
						placeholder="Cédula de Identidad*"
						v-model="numero_identificacion"
						class=" w-full  mt-6" />
					<span class="text-danger text-sm">{{ errors.first('numero_identificacion') }}</span>
				</div>
				<vs-button data-toggle="tooltip" data-placement="bottom" title="Buscar cliente" data-original-title="Buscar cliente" @click="searchIdentificationNumber" size="small" color="success" class="mt-6"><i class="material-icons">search</i></vs-button>
				<vs-button data-toggle="tooltip" data-placement="bottom" title="Limpiar formulario" data-original-title="Limpiar formulario" @click="clearFormCliente" size="small" color="warning" class="ml-6 mt-6"><i class="material-icons">clear_all</i></vs-button>
		</div>
		<div class="vx-row p-4 w-full">
			<div class="vx-col sm:w-1/2 w-full mb-2">
				<vs-input :disabled="estado_email"
					v-validate="'required|email'"
					data-vv-validate-on="blur"
					name="email"
					type="email"
					label-placeholder="Email"
					placeholder="Email*"
					v-model="email"
					class="w-full  mt-6" />
			<span class="text-danger text-sm">{{ errors.first('email') }}</span>
			</div>
			<div class="vx-col  sm:w-1/2 w-full mb-5">
				<vs-input :disabled="estado_nombres"
				v-validate="'required|min:3'"
				data-vv-validate-on="blur"
				label-placeholder="Nombre"
				name="nombres"
				placeholder="Nombres*"
				v-model="nombres"
				class=" w-full  mt-6" />
				<span class="text-danger text-sm">{{ errors.first('nombres') }}</span>
			</div>
			<div class="vx-col sm:w-1/2 w-full mb-2">
				<vs-input :disabled="estado_apellidos"
					v-validate="'required|min:3'"
					label-placeholder="apellidos"
					name="apellidos"
					placeholder="Apellidos*"
					v-model="apellidos"
					class="w-full   mt-6" />
				<span class="text-danger text-sm">{{ errors.first('apellidos') }}</span>
			</div>
			<div class="vx-col sm:w-1/4 w-full mb-2">
				<vs-input :disabled="estado_telefono"
						data-vv-validate-on="blur"
						label-placeholder="telefono"
						name="telefono"
						placeholder="Telefono"
						v-model="telefono"
						class=" w-full mt-6" />
				<span class="text-danger text-sm"></span>
			</div>
			
			<div class="vx-col sm:w-1/4 w-full mb-2">
				<vs-input :disabled="estado_celular"
						data-vv-validate-on="blur"
						label-placeholder="celular"
						name="celular"
						placeholder="Celular"
						v-model="celular"
						class=" w-full  mt-6" />
				<span class="text-danger text-sm"> </span>
			</div>
			<div class="vx-col sm:w-2/2 w-full mb-2">
				<vs-button class="float-right mt-6"  @click="insertarActualizarCliente" :disabled="!validateFormCliente">Registrar</vs-button>
			</div>
		</div>
       </vs-card>
      </vs-col>
    </vs-row>

</template>

<script>
export default {
    data(){
        return {
            listaClientes:[],
            selectCliente:null,
            estado_numero_identificacion:false,
			estado_nombres:true,
			estado_apellidos:true,
			estado_email:true,
			estado_telefono:true,
			estado_celular:true,
            email: '',
			nombres:'',
			apellidos:'',
			numero_identificacion:'',
			telefono:'',
			celular:'',
			cod_persona:'',
            id_usuario_cliente:null,
            cod_cliente:null,
        }
    },
    computed:{
         validateFormCliente() {
            return !this.errors.any() &&
			this.email != '';
        },
         computadaCliente(){
			var cliente = this.selectCliente;
			if(_.isEmpty(cliente)){
				this.clearFormCliente();
			}else{
                this.estado_numero_identificacion = true;
				this.cargaCliente(cliente);
			}    
			return '';
		},
    },
    methods:{
        cargaCliente(cliente){
			this.desblockInputCliente();
            this.email                 = cliente.email;
            this.telefono              = cliente.telefono;
			this.celular               = cliente.celular;
			this.cod_persona           = cliente.cod_persona;
			this.id_usuario            = cliente.id_usuario;
			this.id_usuario_cliente    = cliente.id_usuario_cliente;
			this.numero_identificacion = cliente.numero_identificacion;
			this.apellidos             = cliente.apellidos;
			this.nombres               = cliente.nombres;
			this.email                 = cliente.email;
			this.cod_cliente           = cliente.cod_cliente;
		},
        blockInputCliente(){
			this.estado_numero_identificacion = true;
			this.estado_email                 = true;
			this.estado_nombres               = true;
			this.estado_apellidos             = true;
			this.estado_telefono              = true;
			this.estado_celular               = true;
		},
		desblockInputCliente(){
			this.estado_email    = false;
			this.estado_telefono = false;
			this.estado_celular  = false;
		},
		clearFormCliente(){
			this.blockInputCliente();
            this.id_usuario_cliente           = null;
            this.cod_cliente                  = null;
            this.selectCliente                = null;
			this.estado_numero_identificacion = false;
            this.email                        = '';
			this.nombres                      = '';
			this.apellidos                    = '';
			this.numero_identificacion        = '';
			this.telefono                     = '';
			this.celular                      = '';
			this.cod_persona                  = '';
            this.id_usuario_cliente           = null;
		},
        searchIdentificationNumber(){
			if(_.size(this.numero_identificacion) != 0){
				this.$vs.loading();
				this.$http.post(this.$store.state.domain+`mapgrafi/cliente/cliente-carga-general`,{
							evento:"L1",
                            id_usuario: this.$store.state.AppActiveUser.id_usuario,
							numero_identificacion: (this.numero_identificacion),
                            cod_persona:null,
							estado:"A",
							cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
				})
				.then((response) => {
					this.$vs.loading.close(); 
					if(response.status != 200) throw 'SERVIDOR NO RESPONDE';
					else if (response.data.existeError){
						this.$vs.notify({
										time:8000,
										title: 'Mapgrafi informa',
										text:  response.data.mensaje,
										iconPack: 'feather',
										icon: 'icon-alert-circle',
										color: 'warning'
									})
					} 
					else{
						if(_.size(response.data.data) == 0 ) {
								this.$vs.notify({
									time:8000,
									title: 'Mapgrafi informa',
									text:  'Número de Identificación incorrecta',
									iconPack: 'feather',
									icon: 'icon-alert-circle',
									color: 'warning'
								})
						}
						else{
							this.desblockInputCliente();
							this.insertDataConsultCliente(response.data.data[0]);
						} 
					}  
				})
				.catch((error)=>{
						this.$vs.notify({
							time:8000,
							title: 'Mapgrafi informa',
							text:  error,
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'warning'
						})
				})
			}else{
				this.$vs.notify({
								time:8000,
								title: 'Mapgrafi informa',
								text:  'Ingrese número de Identificación',
								iconPack: 'feather',
								icon: 'icon-alert-circle',
								color: 'warning'
							})
			}
		},
        cargaGeneralCliente(){
				this.$vs.loading();
				this.$http.post(this.$store.state.domain+`mapgrafi/cliente/cliente-carga-general`,{
							evento:"L1",
                            id_usuario: this.$store.state.AppActiveUser.id_usuario,
							numero_identificacion: (null),
                            cod_persona:null,
							estado:"A",
							cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
				})
				.then((response) => {
					this.$vs.loading.close(); 
					if(response.status != 200) throw 'SERVIDOR NO RESPONDE';
					else if (response.data.existeError){
						this.$vs.notify({
										time:8000,
										title: 'Mapgrafi informa',
										text:  response.data.mensaje,
										iconPack: 'feather',
										icon: 'icon-alert-circle',
										color: 'warning'
									})
					} 
					else{
						if(_.size(response.data.data) == 0 ) {
								this.$vs.notify({
								time:8000,
								title: 'Mapgrafi informa',
								text:  'Número de Identificación incorrecta',
								iconPack: 'feather',
								icon: 'icon-alert-circle',
								color: 'warning'
							})
						}
						else{
							// this.desblockInputCliente();
                             this.listaClientes = response.data.data;
						} 
					}  
				})
				.catch((error)=>{
						this.$vs.notify({
							time:8000,
							title: 'Mapgrafi informa',
							text:  error,
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'warning'
						})
				})		
		},
        insertarActualizarCliente(){
			 var cliente = this.selectCliente;
		     
			 this.$vs.loading();
			 this.$http.post(this.$store.state.domain+`mapgrafi/cliente/cliente-insertar-actualizar`,{
				evento					   : (_.isEmpty(this.id_usuario_cliente)) ? 'I' : 'U',
                id_usuario_cliente         : this.id_usuario_cliente,
                id_usuario                 : this.$store.state.AppActiveUser.id_usuario,
        		cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
				id_direccion			   : this.id_direccion, 
             	telefono                   : this.telefono,
				celular                    : this.celular,
                nombres                    : this.nombres,
                apellidos                  : this.apellidos,
                numero_identificacion      : this.numero_identificacion,
                email                      : this.email,
                cod_persona                : this.cod_persona,
                cod_cliente                : this.cod_cliente,
				estado					   : 'A'
          })
          .then((response) => { 
			this.$vs.loading.close(); 
            if(response.status != 200) throw 'SERVIDOR NO RESPONDE';
              else if (response.data.existeError) throw response.data.mensaje;
                else{
					this.$vs.notify({
								time:8000,
								title: 'Success',
								text:  response.data.mensaje,
								iconPack: 'feather',
								icon: 'icon-success-circle',
								color: 'primary'
					});
                    this.cargaGeneralCliente();
                    this.clearFormCliente();
                }  
          })
		.catch((error)=>{
				this.$vs.notify({
					time:8000,
					title: 'Mapgrafi informa',
					text:  error,
					iconPack: 'feather',
					icon: 'icon-alert-circle',
					color: 'warning'
				})
		})	
		},
        validatorOnlineCliente(){
            if(!this.$store.state.AppActiveUser.status)
            this.$router.push('/');
			else{
				this.cargaGeneralCliente();
			}
        },
		insertDataConsultCliente(user){
           	this.email        		   = user.email;
            this.nombres			   = user.nombres;
			this.apellidos             = user.apellidos;
			this.numero_identificacion = user.numero_identificacion;
			this.telefono              = user.telefono;
			this.celular               = user.celular;
			this.cod_persona		   = user.cod_persona;
            this.cod_cliente           = user.cod_cliente;
		},
    },
    created(){
		this.validatorOnlineCliente();
    }
}
</script>